// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"AboutMe_AboutMe__xP-ln","imageContainer":"AboutMe_imageContainer__1Gt6G"};